import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const EarlyDetection = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Button
          variant="ghost"
          className="mb-8"
          onClick={() => navigate(-1)}
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back
        </Button>
        
        <h1 className="text-4xl font-bold mb-6">Early Detection of Cognitive Decline</h1>
        <p className="text-lg text-gray-600 mb-8">
          Our AI-powered monitoring system has shown a 30-35% improvement in early cognitive decline detection through continuous analysis and assessment of patient data.
        </p>
        
        <div className="space-y-6">
          <h2 className="text-2xl font-semibold">Key Advantages</h2>
          <ul className="list-disc list-inside space-y-4 text-gray-600">
            <li>Continuous monitoring for early warning signs</li>
            <li>Advanced pattern recognition in behavioral changes</li>
            <li>Integration with existing clinical workflows</li>
            <li>Personalized risk assessments</li>
            <li>Proactive intervention opportunities</li>
          </ul>
        </div>
      </main>
    </div>
  );
};

export default EarlyDetection;